var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { InputAdornment, IconButton } from '@mui/material';
import { PrivacyOff, PrivacyOn } from '../../assets';
import InputBase from '../InputBase';
import { useCallback, useState } from 'react';
import colors from '../../themes/colors';
var StyledPrivacyOn = styled(PrivacyOn)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & path {\n    fill: ", ";\n  }\n"], ["\n  & path {\n    fill: ", ";\n  }\n"])), function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (disabled ? colors.neutral20 : colors.neutral60);
});
var StyledPrivacyOff = styled(PrivacyOff)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & path {\n    fill: ", ";\n  }\n"], ["\n  & path {\n    fill: ", ";\n  }\n"])), function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (disabled ? colors.neutral20 : colors.neutral60);
});
export default function PasswordInput(props) {
    var placeholder = props.placeholder, helperText = props.helperText, _a = props.error, error = _a === void 0 ? false : _a, onChange = props.onChange, value = props.value, fullWidth = props.fullWidth, onBlur = props.onBlur, disabled = props.disabled, label = props.label;
    var _b = useState(false), showPass = _b[0], setShowPass = _b[1];
    var onShowPass = useCallback(function () {
        if (!disabled)
            setShowPass(!showPass);
    }, [showPass]);
    var type = showPass ? 'text' : 'password';
    return (_jsx(InputBase, { label: label, onBlur: onBlur, fullWidth: fullWidth, type: type, onChange: onChange, value: value, helperText: helperText, error: error, placeholder: placeholder, disabled: disabled, endAdornment: _jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(IconButton, __assign({ disableRipple: true, edge: "end", onClick: onShowPass }, { children: showPass ? _jsx(StyledPrivacyOn, { disabled: disabled }) : _jsx(StyledPrivacyOff, { disabled: disabled }) })) })) }));
}
var templateObject_1, templateObject_2;
